export default "__VITE_ASSET__19731268__"